// Salesman Getters

export const getFullSalesmanList = state => {
  return state.fullSalesmanList
}

export const getSalesmanList = state => {
  return state.salesmanList
}

export const getSalesmanInfo = state => {
  return state.salesmanInfo
}

export const getCommissionList = state => {
  return state.commissionList
}
